import { FunctionComponent } from 'react';

import { Elements } from '@stripe/react-stripe-js';

import useBacsPaymentFormWrapper from './useBacsPaymentFormWrapper';

import BacsPaymentFormError from '../Error';
import BacsPaymentFormLoader from '../Loader';

interface BacsPaymentFormWrapperProps {
  children: React.ReactNode;
}

const BacsPaymentFormWrapper: FunctionComponent<
  BacsPaymentFormWrapperProps
> = ({ children }) => {
  const { isLoading, showError, stripeElementsOptions, stripePromise } =
    useBacsPaymentFormWrapper();

  if (isLoading) return <BacsPaymentFormLoader />;

  if (showError) return <BacsPaymentFormError />;

  return (
    <Elements options={stripeElementsOptions} stripe={stripePromise}>
      {children}
    </Elements>
  );
};

export default BacsPaymentFormWrapper;
